import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { useDebounce } from 'use-debounce';
import { getRepostsList } from '../../Services/ApiServices';
import toast from 'react-hot-toast';
import nodata from "../../Assets/Image/admin/nodata.png";
import { Bars } from "react-loader-spinner";
import { IMG_URL } from '../../Services/Api';

const Reports = () => {
    const [pageNo, setPageNo] = useState(1);
    const [searchData, setSearchData] = useState("");
    const [totalPage, setTotalPage] = useState("1");
    const [reportData, setReportData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [search] = useDebounce(searchData, 1000);
    const navigate = useNavigate();

    const handlExcerciseList = () => {
        setLoader(true);
        let obj = { page: pageNo };

        if (search) {
            obj.search = search;
        }

        getRepostsList(obj)
            .then((res) => {
                setTotalPage(res?.data?.totalPages);
                setLoader(false);
                setReportData(res?.data?.data || []);
            })
            .catch((err) => {
                if (err.response?.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/login");
                } else {
                    toast.error(err?.response?.data?.message);
                }
                setLoader(false);
            });
    };

    const handleSearchChange = (e) => {
        setSearchData(e.target.value);
        setPageNo(1);
    };

    useEffect(() => {
        handlExcerciseList();
    }, [pageNo, search]);

    const renderPaginationButtonss = () => {
        const maxPagesToShow = 3;
        const buttons = [];
        const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
        const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={
                        i === pageNo
                            ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
                            : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
                    }
                >
                    {i}
                </button>
            );
        }
        return buttons;
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPage) {
            setPageNo(page);
        }
    };

    return (
        <>
            <div className="grid grid-cols-12 md:m-4 m-1 fontNew">
                <div className="col-span-12 duration-300 cursor-pointer">
                    <div className="flex items-center justify-end gap-4 mb-4 ">
                        <div className="flex xl:w-70 sm:w-52 w-full h-10 px-4 sm:mb-0 mb-3 rounded-[8px] bg-white items-center">
                            <input
                                type="text"
                                required
                                className="bg-transparent  sm:w-70 w-full border-none outline-none h-10 text-sm fontNew"
                                placeholder="Search..."
                                name="search_text"
                                value={searchData}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                </div>
                {loader ? (
                    <div className="flex justify-center items-center col-span-12 h-[70vh]">
                        <Bars
                            height="35"
                            width="35"
                            color="#FF4433"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>
                ) : (
                    <>
                        {reportData.length === 0 ? (
                            <div className="col-span-12 h-[50vh] justify-center flex items-center">
                                <img src={nodata} className="w-28" alt="No data" />
                            </div>
                        ) : (
                            <div className='bg-white p-5 col-span-12 rounded-xl'>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-5">
                                    {reportData.map((report, index) => (
                                        <div
                                            key={index}
                                            className="flex items-center justify-between border bg-white hover:shadow-lg duration-200 rounded-xl p-4 shadow-sm"
                                        >
                                            <div className="flex items-center gap-4">
                                                <img
                                                    src={IMG_URL + report.profile_image || "https://via.placeholder.com/150"}
                                                    alt={report.firstname}
                                                    className="w-12 h-12 rounded-full object-cover"
                                                />
                                                <div>
                                                    <h2 className="font-semibold">{report.firstname + " " + report.lastname}</h2>
                                                    <p className="text-sm text-gray-500">{report.email_id}</p>
                                                </div>
                                            </div>
                                            <button onClick={() => navigate(`/report_details/${report.id}`)}>
                                                <Eye className="text-gray-400" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <div className="flex col-span-12 justify-end items-center cursor-pointer">
                                    <p
                                        onClick={() => handlePageChange(pageNo - 1)}
                                        disabled={pageNo === 1}
                                    >
                                        Previous
                                    </p>
                                    <div className="flex items-center mx-6">
                                        {renderPaginationButtonss()}
                                    </div>
                                    <p
                                        onClick={() => handlePageChange(pageNo + 1)}
                                        disabled={pageNo === totalPage}
                                    >
                                        Next
                                    </p>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default Reports;
